module.exports = __webpack_public_path__ + "static/media/air-canada-480p.dc1bd228.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/air-canada-480p.mov
// module id = 503
// module chunks = 0